const watchFilters = (urlFilterPrefix = '') => {
    // watch filters object for changes, append changes to url
    return {
        watch: {
            filters: {
                handler(filters){
                    const url = new URL(window.location);
    
                    for ( const key in filters )
                    {
                        url.searchParams.set(urlFilterPrefix ? `${urlFilterPrefix}-${key}` : key, filters[key]);
                    }
    
                    window.history.pushState({}, '', url);
                },
                deep: true
            }
        }
    }
}

export { watchFilters };